import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { trackViewProfileClick } from './helpers/trackingHelpers.ts';

import styles from './FirmDetails.scss';

type Props = {
    firmName: string;
    projectName: string;
    firmProfileImage: string;
    profileLink: string;
    projectLink: string;
    caption: string;
    isLoading?: boolean;
};

type ImageProps = {
    src: string;
    alt: string;
};

const Image: FC<ImageProps> = props => {
    const { src, alt } = props;
    if (!src) {
        return null;
    }
    return <img className={styles.profileIcon} src={`${src}?width=100`} alt={alt} />;
};

const FirmDetails: FC<Props> = ({
    firmName,
    projectName,
    firmProfileImage,
    profileLink,
    projectLink,
    caption,
    isLoading,
}) => {
    return (
        <div className={styles.content}>
            {isLoading ? (
                <span className={styles.profileIconLoading} />
            ) : (
                <Image src={firmProfileImage} alt={firmName} />
            )}
            <div className={styles.info}>
                <Link href={projectLink}>{projectName}</Link>
                <div className={styles.firmName}>
                    <FormattedMessage
                        id="interiorPhoto.firmDetails.firmName"
                        defaultMessage="by {link}"
                        values={{
                            link: (
                                <Link
                                    href={profileLink}
                                    onClick={() => trackViewProfileClick({ action: 'photo' })}
                                >
                                    {firmName}
                                </Link>
                            ),
                        }}
                    />
                </div>
                <div className={styles.caption}>
                    <FormattedMessage
                        id="interiorPhoto.firmDetails.caption"
                        defaultMessage="Photography: {caption}"
                        values={{ caption }}
                    />
                </div>
            </div>
        </div>
    );
};

export default FirmDetails;
